var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPackageDetailsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.50387 0.145987L11.5039 3.06265C11.8111 3.24186 12 3.57077 12 3.92643V8.77769C12 9.13336 11.8111 9.46226 11.5039 9.64147L7.50194 11.9759C7.16861 12.1704 6.75 11.9299 6.75 11.544V7.99433C6.75 7.5613 7.26301 7.33301 7.5847 7.62288L8.29801 8.26562C8.60573 8.54289 9.07996 8.51821 9.35724 8.21049C9.63452 7.90277 9.60984 7.42854 9.30212 7.15127L6.50205 4.62822C6.21672 4.37112 5.78326 4.37112 5.49794 4.62823L2.698 7.15128C2.39029 7.42856 2.36562 7.90279 2.6429 8.21051C2.92018 8.51822 3.39442 8.54289 3.70213 8.26561L4.41529 7.62297C4.73698 7.33309 5.25 7.56138 5.25 7.99441V11.544C5.25 11.9299 4.83139 12.1704 4.49806 11.9759L0.496129 9.64147C0.188911 9.46226 0 9.13336 0 8.77769V3.92643C0 3.57077 0.188911 3.24186 0.496129 3.06265L5.49613 0.145987C5.80749 -0.0356415 6.19251 -0.0356414 6.50387 0.145987Z",
    fill: "#29313D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageDetailsIcon);
export default __webpack_public_path__ + "static/media/package-details-icon.69b20b2697e31bf07531dc918ea25ca9.svg";
export { ForwardRef as ReactComponent };